import moment from 'moment';
import React, { Component } from 'react';
import withRouter from '../../config/WithRouter';
import Axios from '../../config/Axios';
import intl from 'react-intl-universal';
import PageClean from '../default-v2/PageClean';
import EncodedLocalStorage from '../../config/EncodedLocalStorage';
import AuthContext from '../../contexts/Auth';
import { navigateDocumentRoute } from '../../utils/documentV2Navigation';

export class ResponsibleReadModal extends Component {
  static contextType = AuthContext;
  constructor(oProps) {
    super(oProps);

    const { router } = this.props;
    const params = router ? router.params : {};
    this.state = {
      bLoading: true,
      nVersionId: params && params.nVersionId ? params.nVersionId : oProps.nVersionId,
      aPendingReads: [],
      aConfirmedReads: []
    };
  }

  componentDidMount() {
    const { setAlert, router } = this.props;
    const navigate = (router && router.navigate) || (() => { });
    const { nVersionId } = this.state;
    const oLocalStorage = new EncodedLocalStorage();
    const bIsDocumentsV2 = this.context?.oUser?.data?.bIsDocumentsV2 || false;

    Axios.get(`/read/detail/${nVersionId}`)
      .then(oResponse => {
        const { aPendingReads, aConfirmedReads } = oResponse.data;

        Object.keys(aPendingReads).map(cKey => {
          const oUser = aPendingReads[cKey];
          if (oUser.user_nid == oLocalStorage.get('nUserId')) {
            navigateDocumentRoute(navigate, bIsDocumentsV2, `/document/detail/${nVersionId}`, `/folder/${nVersionId}/view`);
            return true;
          }
          return false;
        });

        this.setState({
          aPendingReads,
          aConfirmedReads
        });
      })
      .then(() => {
        this.setState({
          bLoading: false
        });
      })
      .catch(oError => {
        setAlert('error', oError.aMsgErrors);
        this.setState({
          bLoading: false
        });
      });
  }

  renderPendingReads() {
    const { aPendingReads } = this.state;
    const elTable = Object.keys(aPendingReads).map(cKey => {
      const oUser = aPendingReads[cKey];
      return (
        <li role="button" tabIndex="0" key={oUser.user_nid} className="responsibleRead-pendingRead">
          <h3>{oUser.user_cname}</h3>
        </li>
      );
    });
    return elTable;
  }

  renderConfirmedReads() {
    const { aConfirmedReads } = this.state;
    const oLocalStorage = new EncodedLocalStorage();
    const elTable = Object.keys(aConfirmedReads).map(cKey => {
      const oUser = aConfirmedReads[cKey];
      const nLastReading = oUser.version_readings.length - 1;
      return (
        <li
          role="button"
          tabIndex="0"
          key={oUser.version_readings[0].vnrd_nid}
          className="responsibleRead-finishedRead"
        >
          <h3>{oUser.user_cname}</h3>
          <p className="responsibleRead-finishedRead-vnrd_dcreated">
            {moment
              .parseZone(oUser.version_readings[nLastReading].vnrd_dcreated)
              .tz(oLocalStorage.get('cTimezone'))
              .format('DD/MM/YYYY  HH:mm:ss')}
          </p>
        </li>
      );
    });
    return elTable;
  }

  render() {
    const { aPendingReads, aConfirmedReads, bLoading } = this.state;

    return (
      <PageClean loading={bLoading ? 1 : 0}>
        {(aPendingReads.length > 0 || aConfirmedReads.length > 0) && (
          <div className="responsibleRead-info">
            {aPendingReads.length > 0 && (
              <ul className="responsibleRead-pending">
                <h2 className="responsibleRead-title">{intl.get('DocumentReading.pending_reads')}</h2>
                <>
                  <li className="thead no-pointer">
                    <b>{intl.get('user')}</b>
                  </li>
                  {this.renderPendingReads()}
                </>
              </ul>
            )}
            {aConfirmedReads.length > 0 && (
              <ul className="responsibleRead-read">
                <h2 className="responsibleRead-title">{intl.get('DocumentReading.confirmed_reads')}</h2>
                <>
                  <li className="thead no-pointer">
                    <b>{intl.get('user')}</b>
                    <b>{intl.get('DocumentReading.date')}</b>
                  </li>
                  {this.renderConfirmedReads()}
                </>
              </ul>
            )}
          </div>
        )}
      </PageClean>
    );
  }
}

export default withRouter(ResponsibleReadModal);
